<template>
  <!--begin::Content wrapper-->
  <div
    dir="rtl"
    class="modal fade forgetpassword-modal"
    id="addDeviceModal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="exampleModalCenterTitle"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLongTitle">إضافة جهاز</h5>
          <button type="button" class="btn btn-light" data-bs-dismiss="modal">
            <i class="fa fa-close"></i> إغلاق
          </button>
        </div>
        <div class="modal-body text-center" style="">
          <div
            id="reader"
            style="
              width: 500px;
              min-height: 300px;
              margin: 0 auto;
              margin-bottom: 30px;
              background-color: #ddd;
            "
          ></div>
          <!-- QR Code Reader -->
          <div v-if="qrCodeMessage" class="alert alert-default mt-3">
            Scanned QR Code: {{ qrCodeMessage }}
          </div>
          <div v-if="cameraError" class="alert alert-danger mt-3">
            لم نتمكن من تشغيل الكاميرا. يرجى التحقق من الأذونات.
          </div>
          <button
            type="button"
            class="btn btn-success m-3"
            @click="startQrCodeScanner"
            v-if="!isScanning"
          >
            ابدأ مسح QR Code <i class="fa fa-qrcode"></i>
          </button>
          <button
            type="button"
            class="btn btn-danger m-3"
            @click="stopQrCodeScanner"
            v-if="isScanning"
          >
            أوقف المسح
          </button>
          <button
            type="button"
            class="btn btn-secondary"
            data-bs-dismiss="modal"
          >
            عودة
          </button>
        </div>
      </div>
    </div>
  </div>
  <!--end::Content wrapper-->
</template>

<script>
import { Html5Qrcode } from "html5-qrcode";
import { apiUrl, deviceId } from "@/utils/api"; // Adjust the import path according to your project structure
import Swal from "sweetalert2";

export default {
  data() {
    return {
      token: localStorage.getItem("access_token"),
      qrCodeMessage: null,
      qrCodeScanner: null,
      isScanning: false, // Flag to indicate if scanning is active
      cameraError: false, // Flag to indicate camera error
    };
  },
  methods: {
    startQrCodeScanner() {
      this.qrCodeScanner = new Html5Qrcode("reader");
      this.qrCodeScanner
        .start(
          { facingMode: "environment" }, // Use the rear camera
          {
            fps: 10, // Scanning speed
            qrbox: 250, // QR code scanning box size
          },
          (decodedText) => {
            this.handleQrCode(decodedText, deviceId); // Handle the QR code value
            this.stopQrCodeScanner();
          },
          (errorMessage) => {
            console.warn("QR Code scanning error:", errorMessage);
          }
        )
        .then(() => {
          this.isScanning = true; // Set scanning flag to true
          this.cameraError = false; // Reset camera error flag
        })
        .catch((err) => {
          console.error("QR Code scanner failed to start:", err);
          this.cameraError = true; // Set camera error flag
        });
    },
    stopQrCodeScanner() {
      if (this.qrCodeScanner) {
        this.qrCodeScanner
          .stop()
          .then(() => {
            this.qrCodeScanner.clear();
            this.isScanning = false; // Set scanning flag to false
          })
          .catch((err) => {
            console.error("Failed to stop QR Code scanner:", err);
          });
      }
    },
    handleQrCode(qrCodeValue, userdeviceId) {
      const [device_id, device_name] = qrCodeValue.split("//");

      if (!device_id || !device_name) {
        // Show alert if validation fails
        alert("رمز QR غير صالح. يرجى المحاولة مرة أخرى.");
        return;
      }
      this.qrCodeMessage = device_name;

      this.addDevice(device_id, device_name, userdeviceId);
    },
    async addDevice(device_id, device_name, userdeviceId) {
      try {
        const data = {
          user_device_id: userdeviceId, // Assuming deviceId is defined elsewhere
          device_id: device_id,
          device_name: device_name,
        };
        const response = await fetch(`${apiUrl}/devices/add-device`, {
          method: "POST",
          headers: {
            Authorization: `Bearer ${this.token}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify(data),
        });
        if (response.ok) {
          const responseData = await response.json();

          Swal.fire({
            icon: "success",
            title: "تم إضافة الجهاز بنجاح",
            text: "",
          }).then((result) => {
            if (result.isConfirmed) {
              location.reload();
            }
          });
        } else {
          const responseData = await response.json();

          Swal.fire({
            icon: "error",
            title: "حدثت مشكلة ",
            text: responseData.errors,
          }).then((result) => {
            if (result.isConfirmed) {
              location.reload();
            }
          });
        }
      } catch (error) {
        Swal.fire({
          icon: "error",
          title: "حدثت مشكلة ",
          text: "لم يتم إضافة الجهاز بنجاح",
        }).then((result) => {
          if (result.isConfirmed) {
            location.reload();
          }
        });
      } finally {
        this.loading = false;
      }
    },
  },
  beforeUnmount() {
    this.stopQrCodeScanner();
  },
};
</script>

<style scoped>
/* ========== Modal Content ========== */
.modal-content {
  border-radius: 24px !important;
  overflow: hidden;
  border: none;
  box-shadow: 0 25px 80px rgba(0, 0, 0, 0.15);
}

/* ========== Modal Header ========== */
.modal-header {
  background: linear-gradient(135deg, #00c444 0%, #00a43c 100%);
  padding: 20px 24px;
  border: none;
}
.modal-title {
  color: #fff !important;
  font-weight: 700;
  font-size: 1.2rem;
}
.modal-header .btn-light {
  background: rgba(255, 255, 255, 0.2);
  border: none;
  color: #fff;
  border-radius: 12px;
  padding: 8px 16px;
  font-weight: 600;
  transition: all 0.3s ease;
}
.modal-header .btn-light:hover {
  background: rgba(255, 255, 255, 0.3);
  transform: scale(1.05);
}

/* ========== Modal Body ========== */
.modal-body {
  background: linear-gradient(145deg, #f8fffe 0%, #ffffff 100%);
  padding: 30px;
}

/* ========== QR Reader ========== */
#reader {
  border-radius: 20px !important;
  overflow: hidden;
  background: linear-gradient(145deg, #f0fff5 0%, #e8fff1 100%) !important;
  border: 3px dashed rgba(0, 196, 68, 0.3) !important;
  box-shadow: 0 8px 30px rgba(0, 196, 68, 0.1);
}

/* ========== Alerts ========== */
.alert-default {
  background: linear-gradient(135deg, #e8fff1 0%, #d4f7e2 100%);
  border: 1px solid rgba(0, 196, 68, 0.2);
  border-radius: 16px;
  color: #00a43c;
  font-weight: 600;
  padding: 16px 20px;
}
.alert-danger {
  background: linear-gradient(135deg, #fff5f5 0%, #ffe8e8 100%);
  border: 1px solid rgba(220, 53, 69, 0.2);
  border-radius: 16px;
  color: #c82333;
  font-weight: 600;
  padding: 16px 20px;
}

/* ========== Buttons ========== */
.btn-success {
  background: linear-gradient(135deg, #00c444 0%, #00a43c 100%) !important;
  border: none !important;
  border-radius: 14px !important;
  padding: 14px 28px !important;
  font-weight: 600;
  box-shadow: 0 6px 20px rgba(0, 196, 68, 0.3);
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
}
.btn-success::before {
  content: "";
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    90deg,
    transparent,
    rgba(255, 255, 255, 0.2),
    transparent
  );
  transition: left 0.5s ease;
}
.btn-success:hover::before {
  left: 100%;
}
.btn-success:hover {
  transform: translateY(-3px);
  box-shadow: 0 10px 30px rgba(0, 196, 68, 0.4);
}

.btn-danger {
  background: linear-gradient(135deg, #dc3545 0%, #c82333 100%) !important;
  border: none !important;
  border-radius: 14px !important;
  padding: 14px 28px !important;
  font-weight: 600;
  box-shadow: 0 6px 20px rgba(220, 53, 69, 0.3);
  transition: all 0.3s ease;
}
.btn-danger:hover {
  transform: translateY(-3px);
  box-shadow: 0 10px 30px rgba(220, 53, 69, 0.4);
}

.btn-secondary {
  background: linear-gradient(135deg, #6c757d 0%, #5a6268 100%) !important;
  border: none !important;
  border-radius: 14px !important;
  padding: 14px 28px !important;
  font-weight: 600;
  box-shadow: 0 4px 15px rgba(108, 117, 125, 0.3);
  transition: all 0.3s ease;
}
.btn-secondary:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(108, 117, 125, 0.4);
}

/* ========== QR Icon Animation ========== */
.btn-success .fa-qrcode {
  animation: qrPulse 2s ease-in-out infinite;
}
@keyframes qrPulse {
  0%,
  100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.1);
  }
}

/* ========== DARK MODE ========== */
[data-bs-theme="dark"] .modal-content,
[data-theme="dark"] .modal-content,
.dark .modal-content {
  background: #242526;
  border-color: rgba(0, 196, 68, 0.15);
}

[data-bs-theme="dark"] .modal-body,
[data-theme="dark"] .modal-body,
.dark .modal-body {
  background: linear-gradient(145deg, #1a1b1d 0%, #242526 100%);
}

[data-bs-theme="dark"] #reader,
[data-theme="dark"] #reader,
.dark #reader {
  background: linear-gradient(145deg, #1a3d2a 0%, #1e4d35 100%) !important;
  border-color: rgba(0, 196, 68, 0.4) !important;
}

[data-bs-theme="dark"] .alert-default,
[data-theme="dark"] .alert-default,
.dark .alert-default {
  background: linear-gradient(135deg, #1a3d2a 0%, #1e4d35 100%);
  border-color: rgba(0, 196, 68, 0.35);
  color: #8bffb3;
}

[data-bs-theme="dark"] .alert-danger,
[data-theme="dark"] .alert-danger,
.dark .alert-danger {
  background: linear-gradient(135deg, #3d2020 0%, #4a1a1a 100%);
  border-color: rgba(220, 53, 69, 0.35);
  color: #ff8b8b;
}
</style>
